import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "noticeContainer"
}
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "notice_list" }
const _hoisted_4 = ["innerHTML"]


export default /*@__PURE__*/_defineComponent({
  __name: 'cashbackNotice',
  props: {
    content: {
        type: Array,
        default: () => []
    },
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (__props.content?.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('common.cashbackNotice')), 1),
        _createElementVNode("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.content, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              innerHTML: item
            }, null, 8, _hoisted_4))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})